
import { AbstractControl, UntypedFormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { combineLatest as observableCombineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Merges all parameters within the routing tree into a single observable.
 * This allows child routes to access parameters from their parents
 *
 * @param route An activated route
 */
export function routeParams<T = any>(route: ActivatedRoute): Observable<T> {
  return observableCombineLatest([...route.pathFromRoot.map(t => t.params), route.queryParams]
  )
    .pipe(
      map(paramObjects => Object.assign({}, ...paramObjects))
    );
}

export function removeControlsFromFormArray(formArray: UntypedFormArray, controls: AbstractControl[] = []) {
  controls.forEach((fc) => {
    formArray.removeAt(formArray.controls.indexOf(fc));
  });
}
